import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import jizhang from '@/components/jizhang'
import gongshang from '@/components/gongshang'
import shuiwu from '@/components/shuiwu'
import zhichan from '@/components/zhichan'
import xuke from '@/components/xuke'
import renshi from '@/components/renshi'
import xueyuan from '@/components/xueyuan'
import about from '@/components/about'
import contact from '@/components/contact'
import remen from '@/components/remen'
import xinwen from '@/components/xinwen'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Youshi from '@/components/Youshi'
import meta from 'vue-meta'

Vue.use(meta)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  // base: 'sy',  //demo的首页需要开启
  routes: [
    {
      //首页
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '名企科技-北京代理记账|注册公司|注册营业执照|变更注销|工商代办|办理许可证',
        content: {
          keywords: '注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管服务',
          description: '北京名企科技有限公司是专业的财务、税务服务机构。主要业务有：注册公司、提供注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管、商标注册、公司注销、申请高新、审计咨询等服务。名企科技作为专业财务公司，管理规范、服务专业、诚信高效，是中小企业值得信赖的财务代办机构。',
        }
      }
    },
    {
      //代理记账
      path: '/jizhang',
      name: 'jizhang',
      component: jizhang,
      meta: {
        title: '名企科技-北京代理记账|注册公司|注册营业执照|变更注销|工商代办|办理许可证',
        content: {
          keywords: '注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管服务',
          description: '北京名企科技有限公司是专业的财务、税务服务机构。主要业务有：注册公司、提供注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管、商标注册、公司注销、申请高新、审计咨询等服务。名企科技作为专业财务公司，管理规范、服务专业、诚信高效，是中小企业值得信赖的财务代办机构。',
        }
      }
    },
    {
      //工商服务
      path: '/gongshang',
      name: 'gongshang',
      component: gongshang,
      meta: {
        title: '名企科技-北京代理记账|注册公司|注册营业执照|变更注销|工商代办|办理许可证',
        content: {
          keywords: '注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管服务',
          description: '北京名企科技有限公司是专业的财务、税务服务机构。主要业务有：注册公司、提供注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管、商标注册、公司注销、申请高新、审计咨询等服务。名企科技作为专业财务公司，管理规范、服务专业、诚信高效，是中小企业值得信赖的财务代办机构。',
        }
      }
    },
    {
      //税务服务
      path: '/shuiwu',
      name: 'shuiwu',
      component: shuiwu,
      meta: {
        title: '名企科技-北京代理记账|注册公司|注册营业执照|变更注销|工商代办|税务服务',
        content: {
          keywords: '注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管服务',
          description: '北京名企科技有限公司是专业的财务、税务服务机构。主要业务有：注册公司、提供注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管、商标注册、公司注销、申请高新、审计咨询等服务。名企科技作为专业财务公司，管理规范、服务专业、诚信高效，是中小企业值得信赖的财务代办机构。',
        }
      }
    },
    {
      //知识产权
      path: '/zhichan',
      name: 'zhichan',
      component: zhichan,
      meta: {
        title: '名企科技-北京代理记账|注册公司|注册营业执照|变更注销|工商代办|申请高新',
        content: {
          keywords: '注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管服务',
          description: '北京名企科技有限公司是专业的财务、税务服务机构。主要业务有：注册公司、提供注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管、商标注册、公司注销、申请高新、审计咨询等服务。名企科技作为专业财务公司，管理规范、服务专业、诚信高效，是中小企业值得信赖的财务代办机构。',
        }
      }
    },
    {
      //资质许可
      path: '/xuke',
      name: 'xuke',
      component: xuke,
      meta: {
        title: '名企科技-北京代理记账|注册公司|注册营业执照|变更注销|工商代办|代办资质',
        content: {
          keywords: '注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管服务',
          description: '北京名企科技有限公司是专业的财务、税务服务机构。主要业务有：注册公司、提供注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管、商标注册、公司注销、申请高新、审计咨询等服务。名企科技作为专业财务公司，管理规范、服务专业、诚信高效，是中小企业值得信赖的财务代办机构。',
        }
      }
    },
    {
      //人事社保
      path: '/renshi',
      name: 'renshi',
      component: renshi,
      meta: {
        title: '名企科技-北京代理记账|注册公司|注册营业执照|变更注销|工商代办|社保托管',
        content: {
          keywords: '注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管服务',
          description: '北京名企科技有限公司是专业的财务、税务服务机构。主要业务有：注册公司、提供注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管、商标注册、公司注销、申请高新、审计咨询等服务。名企科技作为专业财务公司，管理规范、服务专业、诚信高效，是中小企业值得信赖的财务代办机构。',
        }
      }
    },
    {
      //新闻资讯
      path: '/xueyuan',
      name: 'xueyuan',
      component: xueyuan,
      meta: {
        title: '名企科技-北京代理记账|注册公司|注册营业执照|变更注销|工商代办|办理许可证',
        content: {
          keywords: '注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管服务',
          description: '北京名企科技有限公司是专业的财务、税务服务机构。主要业务有：注册公司、提供注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管、商标注册、公司注销、申请高新、审计咨询等服务。名企科技作为专业财务公司，管理规范、服务专业、诚信高效，是中小企业值得信赖的财务代办机构。',
        }
      }
    },
    {
      // 关于我们
      path: '/about',
      name: 'about',
      component: about,
      meta: {
        title: '名企科技-北京代理记账|注册公司|注册营业执照|变更注销|工商代办|办理许可证',
        content: {
          keywords: '注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管服务',
          description: '北京名企科技有限公司是专业的财务、税务服务机构。主要业务有：注册公司、提供注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管、商标注册、公司注销、申请高新、审计咨询等服务。名企科技作为专业财务公司，管理规范、服务专业、诚信高效，是中小企业值得信赖的财务代办机构。',
        }
      }
    },
    {
      //联系我们
      path: '/contact',
      name: 'contact',
      component: contact,
      meta: {
        title: '名企科技-北京代理记账|注册公司|注册营业执照|变更注销|工商代办|办理许可证',
        content: {
          keywords: '注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管服务',
          description: '北京名企科技有限公司是专业的财务、税务服务机构。主要业务有：注册公司、提供注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管、商标注册、公司注销、申请高新、审计咨询等服务。名企科技作为专业财务公司，管理规范、服务专业、诚信高效，是中小企业值得信赖的财务代办机构。',
        }
      }
    },
    {
      //热门服务
      path: '/remen',
      name: 'remen',
      component: remen,
      meta: {
        title: '名企科技-北京代理记账|注册公司|注册营业执照|变更注销|工商代办|办理许可证',
        content: {
          keywords: '注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管服务',
          description: '北京名企科技有限公司是专业的财务、税务服务机构。主要业务有：注册公司、提供注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管、商标注册、公司注销、申请高新、审计咨询等服务。名企科技作为专业财务公司，管理规范、服务专业、诚信高效，是中小企业值得信赖的财务代办机构。',
        }
      }
    },
    {
      //新闻资讯
      path: '/xinwen',
      name: 'xinwen',
      component: xinwen,
      meta: {
        title: '名企科技-北京代理记账|注册公司|注册营业执照|变更注销|工商代办|办理许可证',
        content: {
          keywords: '注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管服务',
          description: '北京名企科技有限公司是专业的财务、税务服务机构。主要业务有：注册公司、提供注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管、商标注册、公司注销、申请高新、审计咨询等服务。名企科技作为专业财务公司，管理规范、服务专业、诚信高效，是中小企业值得信赖的财务代办机构。',
        }
      }
    },
    {
      //头部组件
      path: '/Header',
      name: 'Header',
      component: Header
    },
    {
      //尾部组件
      path: '/Footer',
      name: 'Footer',
      component: Footer
    },
    {
      path: '/Youshi',
      name: 'Youshi',
      component: Youshi
    }
  ]
})

// 路由守卫，在每次路由切换时更新 meta 标签
router.beforeEach((to, from, next) => {
  // 更新页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // 更新 meta description 和 keywords
  if (to.meta.content) {
    // 更新 description
    const descriptionMeta = document.querySelector('meta[name="description"]');
    if (descriptionMeta) {
      descriptionMeta.setAttribute('content', to.meta.content.description);
    } else {
      const newDescriptionMeta = document.createElement('meta');
      newDescriptionMeta.setAttribute('name', 'description');
      newDescriptionMeta.setAttribute('content', to.meta.content.description);
      document.head.appendChild(newDescriptionMeta);
    }

    // 更新 keywords
    const keywordsMeta = document.querySelector('meta[name="keywords"]');
    if (keywordsMeta) {
      keywordsMeta.setAttribute('content', to.meta.content.keywords);
    } else {
      const newKeywordsMeta = document.createElement('meta');
      newKeywordsMeta.setAttribute('name', 'keywords');
      newKeywordsMeta.setAttribute('content', to.meta.content.keywords);
      document.head.appendChild(newKeywordsMeta);
    }
  }

  next(); // 必须调用 next() 来继续路由导航
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js